import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function ArmsTail() {
	return (
		<g>
			<path className="tail fill fill--half-dark" fill="#EFEFEF" d="M270.56531,352.11194c32.25662,8.18143,72.48856,5.18787,83.866,2.93784
				c18.30356,10.43237,35.45758,12.53442,45.72504,5.33936c2.3783-1.66663,3.4346-4.72308,2.54022-7.48608
				c-3.79947-11.73764-21.56873-13.83365-31.43423-12.61938c1.26636,0.7359,5.94025,4.44858,7.18442,5.03165
				c8.57639,4.01923,18.32077,2.84076,24.7854,0.28055c3.87976-1.5365,5.48706-6.10516,3.44757-9.74576
				c-5.28357-9.43155-23.45065-15.17996-38.34283-14.05978c-11.12177-23.13376-40.06839-46.85913-67.05008-59.97266
				c-24.87335-12.08891-46.60361,5.99557-46.60361,5.99557L270.56531,352.11194z" />
			<path className="arm arm--left fill" fill="#FFFFFF" d="M149.11337,324.72464c-43.52402,16.4971-53.71984,31.27542-47.36438,40.75754
				c8.8624,13.22244,48.16917,13.58276,58.24539,5.94431c4.575-3.46817,25.01741-19.40732,21.66359-29.23431
				C177.62517,330.3757,149.11337,324.72464,149.11337,324.72464z" />
			<path className="arm arm--right fill" fill="#FFFFFF" d="M325.37051,324.72464c43.52405,16.4971,53.71985,31.27542,47.36438,40.75754
				c-8.8624,13.22244-48.16916,13.58276-58.24539,5.94431c-4.57498-3.46817-25.0174-19.40732-21.66357-29.23431
				C296.85873,330.3757,325.37051,324.72464,325.37051,324.72464z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Seal/ArmsTail.js